import React, { ReactNode } from "react";
import { CSSTransition } from "react-transition-group";

interface AnimationProps{
    children: ReactNode,
    shouldRender: boolean
}

const Animation: React.FC<AnimationProps> = (props: AnimationProps) => {
  return (
    <CSSTransition
    in={props.shouldRender}
    timeout={300}
    classNames="alert"
    >
            {props.children}
      </CSSTransition>
  );
};

export default Animation;